export const EMPTY_DESCRIPTION = "ไม่มีข้อมูล";
